import { RouteConfig } from 'vue-router';

export const escalatedAlertStatuses = ['new', 'monitor', 'escalated', 'resolved'] as const;

export const escalatedAlertRoutes: RouteConfig[] = [
	{
		path: '/issues/escalatedAlerts',
		name: 'escalatedAlerts',
		component: () => import(/* webpackChunkName: "account" */ './view.vue'),
		meta: { auth: true },
		redirect: { name: 'escalatedAlerts.new' },
		children: escalatedAlertStatuses.flatMap(status => [
			{
				path: status,
				name: `escalatedAlerts.${status}`,
				meta: { auth: true, alertStatus: status },
			},
			{
				path: `${status}/:alertId`,
				name: `escalatedAlerts.${status}.detail`,
				redirect: {
					name: `escalatedAlerts.${status}.${status === 'resolved' ? 'history' : 'graph'}`,
				},
				meta: { auth: true, alertStatus: status },
			},
			...['graph', 'history', 'users'].map(panel => ({
				path: `${status}/:alertId/${panel}`,
				name: `escalatedAlerts.${status}.${panel}`,
				meta: { auth: true, alertStatus: status, alertPanel: panel },
			})),
		]),
	},
];
